(function () {
	'use strict';

	var module = angular.module('uwAgenda.users');
	module.directive('contactInfoValidation', ['HelperService', 'UserBroadcast', '$timeout', 'UserContactInfoTypeEnum', ContactInfoValidationFn]);

	/* phone mask validation for mobile numbers and email validation */
	/* if rules change, also update server-side validation */
	function ContactInfoValidationFn(HelperService, UserBroadcast, $timeout, UserContactInfoTypeEnum) {

		var directive = {
			require: 'ngModel',
			restrict: 'A',
			scope: {
				countryPrefix: '=', //i.e. '43'
				contactInfoType: '=', // ContactInfoType enum value
				notEmpty: '='
			},
			link: link
		};
		return directive;

		function link(scope, element, attrs, mCtrl) {
			var timeouter = null;
			var listener = null;

			activate();

			function activate() {
				if (scope.contactInfoType === UserContactInfoTypeEnum.Mobile.value ||
					scope.contactInfoType === UserContactInfoTypeEnum.Phone.value) {
					// listen on event
					listener = scope.$on(UserBroadcast.ContactInfoCountryChanged, function () {
						timeouter = $timeout(function () {
							mCtrl.$validate();
						}, 0);
					});
				}
			}

			// valid
			mCtrl.$validators.mobileValid = function (value) {
				if (scope.contactInfoType === UserContactInfoTypeEnum.Mobile.value) {
					if ((!value || value.length === 0) && scope.notEmpty)
					{
						return false;
					}
					return isValidMobile(value);
				}
				return true;
			};
			
			mCtrl.$validators.phoneValid = (value) => {
				if (scope.contactInfoType === UserContactInfoTypeEnum.Phone.value) {
					if ((!value || value.length === 0) && scope.notEmpty)
					{
						return false;
					}
					return isValidPhone(value);
				}
				return true;
			};

			mCtrl.$validators.emailValid = function (value) {
				if (scope.contactInfoType === UserContactInfoTypeEnum.Email.value) {
					if ((!value || value.length === 0) && scope.notEmpty)
					{
						return false;
					}
					return isValidEmail(value);
				}
				else {
					return true;
				}
			};

			// is valid ?
			function isValidMobile(value) {
				return HelperService.validateMobile(value, scope.countryPrefix);
			}

			// is valid ?
			function isValidEmail(value) {
				return HelperService.validateEmail(value);
			}

			function isValidPhone(value) {
				return HelperService.validatePhone(value, scope.countryPrefix);
			}

			// on destroy
			scope.$on("$destroy", function () {
				if (timeouter !== null) {
					$timeout.cancel(timeouter);
				}

				if (listener !== null) {
					listener();
					listener = null;
				}
			});

		}
	}
})();